import React from 'react'
import style from './Loader.module.css'

const Loader = ({ variant = "default" }) => {
  const color = "1, 81, 205";
  const spinner = (
    <div className={style.loader} style={{ "--loader-color": `rgba(${color}, 1)`, "--loader-color-light": `rgba(${color}, 0.5)`, "--loader-color-mid": `rgba(${color}, 0.75)`, "--loader-color-faint": `rgba(${color}, 0.25)` }}></div>
  );
  if (variant === "inline") {
    return spinner;
  }
  return (
    <div className={style.loaderContainer} style={{ "--loader-color": `rgba(${color}, 1)`, "--loader-color-light": `rgba(${color}, 0.5)`, "--loader-color-mid": `rgba(${color}, 0.75)`, "--loader-color-faint": `rgba(${color}, 0.25)` }}>
      {spinner}
    </div>
  );
}

export default Loader